import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">主题索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按类型探索，快速发现你感兴趣的电影世界</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-3">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={`#index`}
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center gap-2 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer text-center no-underline"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full ${
                item.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                item.color === 'secondary' ? 'bg-secondary-100 text-secondary-600' :
                'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.count} 部</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}